<template>
    <oss-dialog
        v-model="openDialog"
        @valid="onClickValidBtbDialog()"
        @close="resetDialog()"
        @previous="previousStep()"
        v-bind="dialogBind"
        width="800px"
    >
        <template v-slot:activator="{ props }">
            <v-tooltip location="bottom">
                <template v-slot:activator="{ props: propsTT }">
                    <v-btn-icon icon="$oss-company" v-bind="{ ...propsTT, ...props }" />
                </template>
                <span>Immeubles</span>
            </v-tooltip>
        </template>
        <v-container class="px-6 pb-6">
            <v-window v-model="step">
                <v-window-item :value="0">
                    <template v-if="!buildings.properties.length">
                        <v-row no-gutters>
                            <v-col cols="12" class="d-flex align-center justify-center py-2">
                                <v-icon class="mr-5" color="secondary" size="large"
                                    >$oss-company</v-icon
                                >
                                <span>Aucun immeuble</span>
                            </v-col>
                        </v-row>
                    </template>
                    <template v-else>
                        <v-row no-gutters class="d-flex justify-center">
                            <v-col cols="12" class="pb-2 title pl-3 text-center"> Immeubles </v-col>
                        </v-row>
                        <v-list-item
                            v-for="(building, i) in buildings.properties"
                            :key="i"
                            class="mb-2"
                        >
                            <v-list-item-title>
                                {{ building.name }}
                            </v-list-item-title>
                            <template v-slot:append class="my-0 d-flex">
                                <v-row no-gutters>
                                    <v-col class="d-flex flex-grow-0 flex-shrink-1">
                                        <v-btn-icon icon="$oss-edit" @click="buildingEdition(i)" />
                                    </v-col>
                                    <v-col class="d-flex flex-grow-0 flex-shrink-1">
                                        <v-btn-icon icon="$oss-trash" @click="removeBuilding(i)" />
                                    </v-col>
                                </v-row>
                            </template>
                        </v-list-item>
                    </template>
                </v-window-item>
                <v-window-item :value="1">
                    <v-row no-gutters>
                        <!-- <v-flex xs3 class="d-flex flex-column align-center justify-center">
                                Nom de l'immeuble :
                            </v-flex> -->
                        <!-- <v-divider vertical></v-divider> -->
                        <v-col cols="12" class="pt-2">
                            <v-text-field-filled
                                label="Nom de l'immeuble"
                                outlined
                                v-model="property.name"
                                hide-details
                                :rules="[(v) => this.isExistingBuilding(v)]"
                                density="compact"
                            />
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="py-3">
                        <v-col cols="12">
                            <h4>Identification</h4>
                        </v-col>
                        <v-col cols="6" class="pt-2">
                            <v-text-field-filled
                                v-model="property.streetNumber"
                                label="Numéro de rue"
                                outlined
                                hide-details
                                density="compact"
                            />
                        </v-col>
                        <v-col cols="6" class="pl-2 pt-2">
                            <v-select-filled
                                v-model="property.BTQ"
                                :items="BTQItems"
                                label="Numéro de rue"
                                outlined
                                hide-details
                                density="compact"
                            />
                        </v-col>
                        <v-col cols="12" class="pt-2">
                            <v-text-field-filled
                                v-model="property.address"
                                label="Adresse"
                                outlined
                                hide-details
                                density="compact"
                            />
                        </v-col>
                        <v-col cols="12" class="pt-2">
                            <v-text-field-filled
                                v-model="property.addressComplement"
                                label="Complément d'adresse"
                                outlined
                                hide-details
                                density="compact"
                            />
                        </v-col>
                        <v-col cols="6" class="pt-2">
                            <v-text-field-filled
                                v-model="property.city"
                                label="Ville"
                                outlined
                                hide-details
                                density="compact"
                            />
                        </v-col>
                        <v-col cols="6" class="pt-2 pl-2">
                            <v-text-field-filled
                                v-model="property.country"
                                label="Pays"
                                outlined
                                hide-details
                                density="compact"
                            />
                        </v-col>
                        <v-col cols="4" class="pt-2">
                            <v-text-field-filled
                                v-model="property.postalCode"
                                label="Code Postal"
                                outlined
                                hide-details
                                density="compact"
                            />
                        </v-col>
                        <v-col cols="4" class="pt-2 pl-2">
                            <oss-text-field-filled
                                v-model="property.numberOfRooms"
                                label="Nombre de locaux"
                                density="compact"
                                hide-details
                            />
                        </v-col>
                        <v-col cols="4" class="pt-2 pl-2">
                            <oss-date-picker-filled
                                label="Date d'acquisition"
                                v-model="property.acquiredDate"
                                :textFieldReadOnly="false"
                                :text-field-readonly="false"
                                hide-details="auto"
                            />
                        </v-col>
                    </v-row>
                    <v-divider />
                    <v-row no-gutters class="pt-1 pb-3">
                        <v-col cols="12" class="pb-2">
                            <h4>Nature</h4>
                        </v-col>
                        <v-col cols="6" class="pr-1">
                            <v-select-filled
                                class="pr-1"
                                hide-details
                                v-model="property.natureA"
                                :items="natureA"
                                :item-props="true"
                                item-title="description"
                                item-value="description"
                                label="Immeuble A"
                                density="compact"
                            >
                                <template #item="{ props }">
                                    <v-list-item v-bind="props">
                                        <template #prepend>
                                            <v-avatar color="secondary" size="small">{{
                                                props.icon
                                            }}</v-avatar>
                                        </template>
                                    </v-list-item>
                                </template>
                            </v-select-filled>
                        </v-col>
                        <v-col cols="6" class="pl-1">
                            <v-select-filled
                                class="pl-1"
                                hide-details
                                outlined
                                v-model="property.natureB"
                                :items="natureB"
                                :item-props="true"
                                item-title="description"
                                item-value="description"
                                label="Immeuble B"
                                density="compact"
                            >
                                <template #item="{ props }">
                                    <v-list-item v-bind="props">
                                        <template #prepend>
                                            <v-avatar color="secondary" size="small">{{
                                                props.icon
                                            }}</v-avatar>
                                        </template>
                                    </v-list-item>
                                </template>
                            </v-select-filled>
                        </v-col>
                    </v-row>
                    <v-divider />
                    <v-row no-gutters class="pt-1">
                        <v-col cols="12" class="pb-2">
                            <h4>Déduction</h4>
                        </v-col>
                        <v-col cols="6" class="pr-1">
                            <v-text-field-filled
                                v-model="property.specificDeduction"
                                label="Déduction spécifique"
                                outlined
                                hide-details
                                density="compact"
                            />
                        </v-col>
                        <v-col cols="6" class="pl-1">
                            <v-text-field-filled
                                v-model="property.depreciationDeduction"
                                label="Déduction amortissement"
                                outlined
                                hide-details
                                density="compact"
                            />
                        </v-col>
                    </v-row>
                </v-window-item>
            </v-window>
        </v-container>
    </oss-dialog>
</template>

<script lang="ts">
import { Apollo } from "@/decorators";
import gql from "graphql-tag";
import _ from "lodash";

import settingCard from "../SettingCard.vue";

import UPSERT_BUILDINGS from "../../../graphql/UpsertBuildings.gql";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    components: {
        settingCard,
    },
    emits: ["updateProfile", "onUpdate"],
})
export class SettingSCI extends Vue {
    @Prop({ default: "" }) companyId: string;

    step = 0;
    refreshKey = 0;
    index = -1;
    displayValid = false;
    edition = false;

    openDialog = false;

    defaultProperty = {
        streetNumber: "",
        BTQ: "",
        name: "",
        address: "",
        addressComplement: "",
        postalCode: "",
        city: "",
        country: "",
        natureA: "",
        natureB: "",
        specificDeduction: "",
        depreciationDeduction: "",
        numberOfRooms: "",
        acquiredDate: "",
    };

    property = _.cloneDeep(this.defaultProperty);

    get BTQItems() {
        return [
            { title: "", value: "" },
            { title: "Bis", value: "B" },
            { title: "Ter", value: "T" },
            { title: "Quater", value: "Q" },
        ];
    }

    get natureA() {
        const types = [
            { icon: "U", description: "Immeuble urbain" },
            { icon: "R", description: "Immeuble rural" },
            { icon: "IR", description: "Immeuble de rapport" },
            { icon: "AP", description: "Appartement" },
            { icon: "M", description: "Maison" },
            { icon: "P", description: "Parking" },
            { icon: "AU", description: "Autre qualification" },
        ];
        return types;
    }

    get natureB() {
        const types = [
            { icon: "B", description: "Bâti" },
            { icon: "NB", description: " Non bâti" },
        ];
        return types;
    }

    get validTitle() {
        if (this.step === 0) {
            return "Ajouter un nouvel immeuble";
        } else {
            if (this.edition) {
                return "Modifier";
            }
            return "Ajouter";
        }
    }

    get binds() {
        return {
            title: "Société civile immobilière",
            partnerName: "bobbee",
            text: "Définissez la liste des renseignements sur les immeubles nécessaires pour les SCI.",
            // logo: BobbeeImg
        };
    }

    get dialogBind() {
        return {
            title: "",
            "valid-title": this.validTitle,
            validDisabled: this.invalid(),
            "hide-valid": false, //[0].includes(this.step),
            "previous-display": this.step !== 0,
        };
    }

    @Apollo({
        query: gql`
            query CompanyBuildings($companyId: ID!) {
                company(where: { id: $companyId }) {
                    id
                    buildings
                }
            }
        `,
        variables() {
            return {
                companyId: this.companyId,
            };
        },
        skip() {
            return !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            this.loading = loading;
            if (!loading && data) {
                if (data.company?.buildings) {
                    this.buildings = { ...this.defaultProperty, ...data.company.buildings };
                }
            }
        },
    })
    buildings = {
        properties: [],
    };

    previousStep() {
        if (this.step === 1) {
            this.resetDialog();
        }
    }

    async onClickValidBtbDialog() {
        switch (this.step) {
            case 0: {
                this.step = 1;
            }
            case 1: {
                if (!this.buildingInvalid()) {
                    if (this.edition) {
                        this.buildings.properties.splice(this.index, 1, this.property);
                    } else {
                        this.buildings.properties.push(this.property);
                    }
                    await this.updateProfile();
                    this.refreshKey++;
                    this.resetDialog();
                }
                debugger;
            }
        }
    }

    buildingEdition(index) {
        this.edition = true;
        this.step = 1;
        this.index = index;
        this.property = JSON.parse(JSON.stringify(this.buildings.properties[index]));
    }

    buildingInvalid() {
        let buildingKeys = Object.keys(this.property).filter(
            (k) => !k.toLowerCase().includes("deduction")
        );
        for (const key of buildingKeys) {
            if (key === "BTQ" || key === "addressComplement") {
                continue;
            }
            if (this.property[key] === "") {
                return true;
            }
        }
        return false;
    }

    isExistingBuilding(value) {
        const isExisting = this.buildings.properties.some(
            (building) => building.name.toLowerCase() === value.toLowerCase()
        );
        return isExisting ? "Cet immeuble existe déjà" : true;
    }

    invalid() {
        if (this.step === 0) {
            return false;
        }
        if (this.step === 1) {
            return this.buildingInvalid();
        }
        return true;
    }

    mergeOn(on, onDialog) {
        return {
            ...on,
            ...onDialog,
        };
    }

    async updateProfile() {
        let result = await this.$apollo.mutate({
            mutation: UPSERT_BUILDINGS,
            variables: {
                companyId: this.companyId,
                buildings: this.buildings,
            },
        });
        // if(result) {
        // }
        // this.$emit("updateProfile")
    }

    async removeBuilding(index) {
        const tagName = this.buildings.properties[index].name;
        this.buildings.properties.splice(index, 1);
        let result = await this.$apollo.mutate({
            mutation: UPSERT_BUILDINGS,
            variables: {
                companyId: this.companyId,
                buildings: this.buildings,
                tagName: tagName,
            },
        });
    }

    refresh() {
        this.$emit("onUpdate");
    }

    resetDialog() {
        // debugger
        this.property = _.cloneDeep(this.defaultProperty);
        this.step = 0;
        this.refreshKey++;
        this.index = -1;
        this.edition = false;
    }
}

export default toNative(SettingSCI);
</script>
